<template>
  <div class="vmp-custom-menu-thirdLink" ref="iframe_third_link">
    <div class="thirdLink-previewBox">
      <!-- <div class="opts">
        <i
          :class="{
            'vh-iconfont': true,
            'vh-a-line-fullscreen': fullScreenStatus == 'full_screen',
            'vh-a-line-exitfullscreen': fullScreenStatus == 'exit_screen'
          }"
          @click="toggleFullScreen('iframe_third_link')"
        ></i>
      </div> -->
      <iframe
        class="iframe-label"
        v-show="linkUrl"
        allow="camera *;microphone *; display-capture"
        allowfullscreen="true"
        border="0"
        :src="linkUrl"
        width="100%"
        :height="info.pageHeight"
      ></iframe>
    </div>
  </div>
</template>

<script>
  import { useRoomBaseServer } from 'middle-domain';
  import { getParam, parseQueryString } from '@/app-shared/utils/tool';
  export default {
    name: 'component-third-link',
    props: {
      info: {
        required: false
      }
    },
    data() {
      return {
        // fullScreenStatus: 'full_screen' //默认显示全屏图标
      };
    },
    computed: {
      // VH_DEP_third_user_id() {
      //   return this.roomBaseServer.state.watchInitData.join_info.third_party_user_id;
      // },
      VH_DEP_webinar_id() {
        return this.roomBaseServer.state.watchInitData.webinar.id;
      },
      VH_DEP_user_nick_name() {
        return this.roomBaseServer.state.watchInitData.join_info.nickname;
      },
      VH_DEP_user_avatar() {
        return this.roomBaseServer.state.watchInitData.join_info.avatar;
      },
      //加载的链接地址
      linkUrl() {
        return this.buildUrlParams(this.info.url, this.info.checkedUrlParams);
      }
    },
    beforeCreate() {
      this.roomBaseServer = useRoomBaseServer();
    },
    mounted() {
      console.log('component-third-link-------------->', this.info);
    },
    methods: {
      /**
       * 构建地址栏参数
       * 开放平台嵌入地址参数规则
       * https://saas-doc.vhall.com/opendocs/show/1282
       * @param {any} url 原数据地址
       * @param {any} checkedUrlParams 增加的地址栏参数
       * @returns {any}
       */
      buildUrlParams(url, checkedUrlParams) {
        const urlObj = new URL(url);
        checkedUrlParams.reduce((accumulator, currentValue) => {
          if (currentValue == 'VH_DEP_third_user_id') {
            let currentUrlParams = parseQueryString(location.href);
            // 开放平台嵌入地址参数规则
            if (currentUrlParams['third_user_id']) {
              // accumulator[currentValue] = currentUrlParams['third_user_id'];
              urlObj.searchParams.append(currentValue, currentUrlParams['third_user_id']);
            }
          } else {
            // accumulator[currentValue] = this[currentValue]; // 设定默认值为空字符串
            urlObj.searchParams.append(currentValue, this[currentValue]);
          }
          // return accumulator;
        }, {});
        return urlObj.toString();
      }
      /**
       * 统一全屏方法
       * @param {any} iframe
       * @param {any} callback 回调函数
       * @returns {any}
       */
      // fullScreen(iframe, callback) {
      //   if (!document.fullscreenElement) {
      //     if (iframe.requestFullscreen) {
      //       iframe.requestFullscreen();
      //     } else if (iframe.mozRequestFullScreen) {
      //       /* Firefox */
      //       iframe.mozRequestFullScreen();
      //     } else if (iframe.webkitRequestFullscreen) {
      //       /* Chrome, Safari & Opera */
      //       iframe.webkitRequestFullscreen();
      //     } else if (iframe.msRequestFullscreen) {
      //       /* IE/Edge */
      //       iframe.msRequestFullscreen();
      //     }
      //     callback('exit_screen');
      //   } else {
      //     if (document.exitFullscreen) {
      //       document.exitFullscreen();
      //     } else if (document.mozCancelFullScreen) {
      //       /* Firefox */
      //       document.mozCancelFullScreen();
      //     } else if (document.webkitExitFullscreen) {
      //       /* Chrome, Safari & Opera */
      //       document.webkitExitFullscreen();
      //     } else if (document.msExitFullscreen) {
      //       /* IE/Edge */
      //       document.msExitFullscreen();
      //     }
      //     callback('full_screen');
      //   }
      // },
      // 按钮点击全屏
      // toggleFullScreen(currentDom) {
      //   let dom = this.$refs[currentDom];
      //   this.fullScreen(dom, value => {
      //     this.fullScreenStatus = value;
      //   });
      // }
    }
  };
</script>
<style lang="less" scoped>
  .vmp-custom-menu-thirdLink {
    max-width: 100%;
    height: auto;
    margin: 0px 24px 20px 24px;
    .iframe-label {
      border: none;
    }
    .thirdLink-previewBox {
      position: relative;
      // .opts {
      //   padding: 10px;
      //   display: flex;
      //   justify-content: flex-end;
      //   color: var(--chat-font-color-msg-text);
      //   background-color: var(--chat-background-color-secondary);
      //   font-size: 28px;
      //   .vh-iconfont {
      //     cursor: pointer;
      //   }
      // }
    }
  }
</style>
